import config from 'SRC/config/config.yaml'

export const adsListViews = config.adsList.adsListViews
